import React, { Component } from "react";
import { Float } from "@cnsit/js";
import { L } from "../components/L";
import { C } from "../components/C";
import { F } from "../components/F";

export class FCL extends Component {
  constructor(props) {
    super(props);
    this.state = {
      f: props.f,
      c: props.c
    };
    this.onFChange = this.onFChange.bind(this);
    this.onCChange = this.onCChange.bind(this);
    this.calc = this.calc.bind(this);
    this.f = React.createRef();
    this.c = React.createRef();
  }
  componentDidMount() {
    this.setState(
      {
        f: this.f.current.unify(),
        c: this.c.current.unify()
      },
      () => {
        this.calc();
      }
    );
  }
  onFChange(id, value) {
    this.setState({ f: value }, () => {
      this.calc();
    });
  }
  onCChange(id, value) {
    this.setState({ c: value }, () => {
      this.calc();
    });
  }
  calc() {
    let temp = new Float(this.state.f);
    temp.mul(Math.PI).mul(2).pow(2).mul(this.state.c);
    this.setState({ l: new Float(1).div(temp) }, () => {
      console.log("FCL calc - setState");
    });
  }
  render() {
    return (
      <div className="calculator">
        <F
          value={this.props.f}
          onChange={this.onFChange}
          caption="频率"
          ref={this.f}
        />
        <C
          value={this.props.c}
          onChange={this.onCChange}
          caption="电容"
          ref={this.c}
        />
        <L value={this.state.l} readonly={true} />
      </div>
    );
  }
}
